import { useQuery } from '@tanstack/react-query';
import { getMySubscription } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';

export const useMySubscription = (options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: queryKeys.subscription.me(),
        queryFn: getMySubscription,
        enabled: options?.enabled ?? true,
    });
};
